"use strict";

jQuery(function () {
  /* SLIDER */
  var teamSectionSlider = new Swiper('.js__team-section-slider', {
    slidesPerView: 4,
    spaceBetween: 10,
    resistance: false,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-team-section',
      prevEl: '.swiper-button-prev-team-section'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      481: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    }
  });
  var fourColumnProductSlider = new Swiper('.js__four-column-product-slider', {
    slidesPerView: 4,
    spaceBetween: 10,
    resistance: false,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-four-column-product',
      prevEl: '.swiper-button-prev-four-column-product'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      481: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    }
  });
  var twoColumnSlider = new Swiper('.js__two-column-slider', {
    slidesPerView: 2,
    spaceBetween: 30,
    resistance: false,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-two-column',
      prevEl: '.swiper-button-prev-two-column'
    }
  });
  var twoColumnSlider = new Swiper('.js__three-column-slider', {
    slidesPerView: 3,
    spaceBetween: 30,
    resistance: false,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-two-column',
      prevEl: '.swiper-button-prev-two-column'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      769: {
        slidesPerView: 2
      },
      1100: {
        slidesPerView: 3
      }
    }
  });
  var fullWidthImageSlider = new Swiper('.js__full-width-image-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    resistance: false,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-full-width-image',
      prevEl: '.swiper-button-prev-full-width-image'
    }
  });
  var testimonialSlider = new Swiper('.js__testimonial-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    resistance: false,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 5000
    },
    navigation: {
      nextEl: '.swiper-button-next-testimonial',
      prevEl: '.swiper-button-prev-testimonial'
    }
  });
  $('.js__product-description-readMore').on('click', function () {
    if ($(this).parent('div').children('.product-description').css('display') == 'none') {
      $(this).parent('div').children('.product-description').slideDown('slow');
      $(this).html('+ Read Less');
    } else {
      $(this).parent('div').children('.product-description').slideUp('slow');
      $(this).html('+ Read Full Review');
    }

    var target = $(this).parent('.js__product-description-outer').parent('.content').children('.product-card__product-title');
    $('html, body').animate({
      scrollTop: target.offset().top - 350
    }, 500);
  });
  /* PDP
        Tab working */
  //   $('.tab-link').on('click', function () {
  //     var dataId = $(this).attr('data-attr');
  //     var i, tabcontent, tablink;
  //     tabcontent = document.getElementsByClassName('tab-content');
  //     for (i = 0; i < tabcontent.length; i++) {
  //       tabcontent[i].style.display = 'none';
  //     }
  //     tablink = document.getElementsByClassName('tab-link');
  //     for (i = 0; i < tablink.length; i++) {
  //       tablink[i].className = tablink[i].className.replace(
  //         ' active',
  //         ''
  //       );
  //     }
  //     document.getElementById(dataId).style.display = 'block';
  //     event.currentTarget.className += ' active';
  //     /*PDP select*/
  //     $('.js__pdp-tab-select').val(dataId);
  //   });

  $('.js__accordian').not('.calculateShippingAccordion').children('li:first-child').addClass('active');
  $('.calculateShippingAccordion').children('li:first-child').removeClass('active');
  /* accordion working about content in small screen*/

  $('.js__accordian').children('li').children('h5,h6,h3').click(function (e) {
    if ($(this).parent('li').children('.content').css('display') == 'none') {
      $(this).parent('li').parent('.js__accordian').children('li').children('.content').hide();
      $(this).parent('li').parent('.js__accordian').children('li').removeClass('active');
      $(this).parent('li').children('.content').slideDown();
      $(this).parent('li').addClass('active');
      /* $('html,body').animate({
                scrollTop: $(this).offset().top - 120
              }, 500);*/
    } else {
      $(this).parent('li').children('.content').slideUp();
      $(this).parent('li').removeClass('active');
    }
  });
  $(document).ready(function () {
    $('.tab-link').click(function () {
      var dataTab = $(this).attr('data-tab'); // Remove 'active' class from all tabs and hide all content

      $('.tab-link').removeClass('active');
      $('.tab-content').hide(); // Add 'active' class to clicked tab and show corresponding content

      $(this).addClass('active');
      $('.tab-content[data-tab="' + dataTab + '"]').show();
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // Find all the start and end elements
  var startElements = document.querySelectorAll('.bgWrap--start');
  var endElements = document.querySelectorAll('.bgWrap--end'); // Assuming each start element has a corresponding end element

  startElements.forEach(function (startEl, index) {
    var startSection = startEl.closest('.shopify-section');
    var endSection = endElements[index] ? endElements[index].closest('.shopify-section') : null;

    if (startSection && endSection) {
      var currentNode = startSection.nextElementSibling;
      var nodesToWrap = []; // Collect all shopify-section nodes between this start and end element

      while (currentNode && currentNode !== endSection) {
        nodesToWrap.push(currentNode);
        currentNode = currentNode.nextElementSibling;
      }

      if (nodesToWrap.length > 0) {
        // Create a new div to wrap the sections
        var wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'bg-wrap dark-gradiant base no-graphics'); // Insert the wrapper before the first node to wrap

        startSection.parentNode.insertBefore(wrapper, nodesToWrap[0]); // Move each node into the wrapper

        nodesToWrap.forEach(function (node) {
          return wrapper.appendChild(node);
        });
      }
    }
  });
});